import {
  useAPIGetPelaksanaanList,
  useAPIGetPelaksanaanFilter,
} from 'api/kinerja/tim-penilai-penilik/pelaksanaan'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { PelaksanaanFilterState } from 'types/kinerja-tim-penilai-penilik'

export default function usePelaksanaanList({
  filter,
}: {
  filter: PelaksanaanFilterState
}) {
  const { isPPKPenilik, isTKPenilik, isProfilePenilikPegawaiFetched } =
    useRoleContext()

  const {
    data: summary,
    isLoading: isSummaryLoading,
    isFetched: isSummaryFetched,
  } = useAPIGetPelaksanaanFilter({
    enabled: isProfilePenilikPegawaiFetched && (isPPKPenilik || isTKPenilik),
  })

  const {
    data,
    isLoading: isListLoading,
    isFetched: isListFetched,
  } = useAPIGetPelaksanaanList({
    filter,
    enabled: isProfilePenilikPegawaiFetched && (isPPKPenilik || isTKPenilik),
  })

  return {
    data,
    summary,
    isLoading: isListLoading || isSummaryLoading,
    isFetched: isListFetched && isSummaryFetched,
  }
}
